
import { mapGetters } from 'vuex'
export default {
    name: 'PromotionPage',
    data: () => ({
        claimPromotion: null,
        valid: true,
        loading: false,
    }),
    computed: {
        ...mapGetters({
            promotion: 'cms/promotion',
            promotions: 'themes/promotion/availablePromotions',
        }),
    },
    async mounted() {
        this.loading = true
        if (this.promotions.length === 0) {
            await this.$store.dispatch(
                'themes/promotion/getAvailablePromotions'
            )
        }
        this.loading = false
    },
    methods: {
        onClaim() {
            if (this.claimPromotion) {
                if (this.$cookie.get('token')) {
                    this.$store.dispatch(
                        'promotion/promotionCode',
                        this.claimPromotion
                    )
                } else {
                    this.$router.push('/login')
                }
            }
        },
    },
}
